import React from "react";
import PeriodDropdown from "./dropdown/period-dropdown";
import { Bar } from "react-chartjs-2";
export default function BarChart({ title, userCountText, options = [], data, onPeriodChange }) {
    const barOptions = {
        responsive: true,
        indexAxis: "y",
        scales: {
            x: {
                ticks: {
                    callback: function (tickValue, index, ticks) {
                        return `${tickValue}%`;
                    }
                },
                max: 100
            }
        },
        plugins: {
            legend: {
                display: false
            }
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative bg-white p-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between mb-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-base font-medium text-gray-500"
    }, title)), /*#__PURE__*/ React.createElement("div", {
        className: "text-2xl font-bold text-blue-600 mb-4"
    }, userCountText), options.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "absolute right-10 top-5"
    }, /*#__PURE__*/ React.createElement(PeriodDropdown, {
        options: options,
        onChange: onPeriodChange
    })), /*#__PURE__*/ React.createElement(Bar, {
        data: data,
        options: barOptions
    }));
}
